export enum MatchStatus {
  Pending = 'Pending',
  Matched = 'Matched',
  Closed = 'Closed',
  AwaitingFeedback = 'Awaiting Feedback',
  ForReview = 'For Review',
  AdminDeclined = 'admin declined',
  Declined = 'Declined',
  Withdrawn = 'Withdrawn',
}
